import { render, staticRenderFns } from "./BulkShipmentImportPage.vue?vue&type=template&id=7d483fa0"
import script from "./BulkShipmentImportPage.vue?vue&type=script&lang=js"
export * from "./BulkShipmentImportPage.vue?vue&type=script&lang=js"
import style0 from "./BulkShipmentImportPage.vue?vue&type=style&index=0&id=7d483fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports